<template>
  <nav class="results-table-droplist w-dropdown-list">
    <div :class="{'no-teeth': !products[0].teeth.length}" class="order-detail-wrap">
      <div class="order-top">
        <TeethInfo
          v-if="products[0].teeth.length"
          :teeth="teethTotal"
          :products="products"
        />
        <ScansInfo
          :client-scans="updatedClientScans"
          :lab-scans="order.lab_scans || []"
          :orderId="order.id"
          :tab="tab"/>
      </div>
      <OrderInfo
        :order="order"
        :hide-price="hidePrice"
        :hide-ready-date="hideReadyDate"
      />

      <div v-if="order.scanner_type" class="additional-param">
        <div class="info-hor m-vertical">
          <div class="text-secondary ts-label">Вид сканера<br></div>
          <div class="text">{{ order.scanner_type.type }}<br></div>
        </div>
      </div>

      <div v-if="order.comment" class="order-comment">
        <div class="label">Комментарий к заказу</div>
        <div class="text">{{order.comment}}</div>
      </div>
    </div>

    <!-- Mobile close button -->
    <div class="close-drop w-inline-block" @click="$emit('open')">
      <div class="icon-12px"><CloseIcon /></div>
    </div>
  </nav>
</template>

<script>
  import CloseIcon from '@/icons/close.svg';
  import OrderInfo from '@/containers/orders/container/OrderInfo';
  import TeethInfo from '@/containers/orders/container/TeethInfo';
  import ScansInfo from '@/containers/orders/container/ScansInfo';

  export default {
    name: 'OrderDetails',
    components: {
      ScansInfo,
      TeethInfo,
      OrderInfo,
      CloseIcon,
    },
    props: {
      order: {
        type: Object,
        required: true,
      },
      tab: String,
      hidePrice: Boolean,
      hideReadyDate: Boolean,
    },
    computed: {
      products () {
        return this.order.products || [];
      },
      teethTotal () {
        const res = new Set();
        for (let i = 0; i < this.products.length; i++) {
          this.products[i].teeth.forEach(tooth => res.add(tooth));
        }
        return Array.from(res);
      },
    },
    data () {
      return {
        updatedClientScans: this.order.client_scans,
      };
    },
  };
</script>

<style scoped>
  .order-comment {
    padding: 20px;
    border-radius: 4px;
    background-color: rgba(32, 37, 58, 0.04);
  }
</style>
